import { DraggableWindowHeader } from "@hoylu/client-common";
import React, { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import type { WorkspaceLabels } from "../../state/workspaces/types";
import * as workspacesActions from "../../state/workspaces/workspaces.actions";
import {
  selectIsFetchingDashboardLabels,
  selectSelectedWorkspace,
  selectWorkspacesAllLabels,
} from "../../state/workspaces/workspaces.selector";
import { useI18n } from "../../utils/hooks/use.i18n";
import { EditLabelContent } from "./EditLabelContent";
import Styles from "./EditLabelDialog.module.css";
import { Modal } from "./Modal";

export const EditLabel = () => {
  const dispatch = useDispatch();

  const t = useI18n("EDIT_LABEL_DIALOG.");
  const tClose = useI18n("CLOSE_BUTTON.");

  const selectedWorkspace = useSelector(selectSelectedWorkspace);
  const isLoadingLabels = useSelector(selectIsFetchingDashboardLabels);
  const workspaceLabels = useSelector(selectWorkspacesAllLabels);

  useEffect(() => {
    dispatch(workspacesActions.getDashboardLabels.request());
  }, []);

  const closeHandler = useCallback(() => {
    dispatch(workspacesActions.cancelDashboardOption());
  }, [dispatch]);

  const requestUpdateLabels = (labels: WorkspaceLabels) => {
    if (selectedWorkspace?.workspaceId) {
      dispatch(
        workspacesActions.updateWorkspaceLabels.request({
          labels,
          workspaceId: selectedWorkspace.workspaceId,
        }),
      );
    }
  };

  return (
    <Modal handleOutsideClick={closeHandler}>
      <div className={Styles.editLabelDialog}>
        <DraggableWindowHeader
          close={tClose("CLOSE")}
          onClose={closeHandler}
          title={t("LABELS")}
        />
        {!isLoadingLabels ? (
          <EditLabelContent
            allLabels={workspaceLabels}
            selected={selectedWorkspace?.labels}
            updateSelected={requestUpdateLabels}
          />
        ) : (
          <h1 className={Styles.loadingHeader}>{t("LOADING")}</h1>
        )}
      </div>
    </Modal>
  );
};

export default EditLabel;
